import { FC } from "react";
import LoginForm from "../../components/Form/LoginForm";

const LoginPage: FC = () => {
  return <LoginForm />;
};

export default LoginPage;
